
const Loading = () => {
    return(
        <div className='w-[30px] h-[30px] rounded-full border border-4 border-gray-300 border-r-black mx-auto animate-spin'>
        </div>
    )
}

export default Loading